import $ from 'jquery';
import Svg4everybody from 'Svg4everybody'; // for <use xlink:href> support within IE

import './vendor/bootstrap';
import branchBar from './modules/branch-bar';
import navs from './modules/navs.js';
import searchPane from './modules/search-pane.js';
import textSize from './modules/text-size.js';
import modal from './modules/modal';
import videoLiftUp from './modules/video-lift-up.js';
import footnotes from './modules/footnotes.js';
import getUrlParam from './modules/get-url-param.js';
import scrollTo from './modules/scroll-to.js';
import notification from './modules/notification';
import toggle from './modules/toggle';
import CookieDialog from './modules/cookie-dialog';

//Initialize everything on document ready
$(document).ready(() => {
  Svg4everybody();
  navs.init();
  searchPane.init();
  textSize.init();
  modal.init();
  videoLiftUp.init();
  footnotes.init();
  notification.init();
  branchBar.init();
  toggle.init();

  const scrollToElementId = getUrlParam('shared');
  if(scrollToElementId){
    scrollTo('#'+scrollToElementId);
  }

  const cookieDialogElement = document.getElementById('cookie-dialog');
  if (cookieDialogElement) {
    new CookieDialog(cookieDialogElement);
  }
});
